import React from "react";
import Tooltip from "./Tooltip.jsx";

// Help text with Tooltip. This component contains only the functionality. Styling needs to be added separately
const Help = ({ text, className, style, trigger = "click", options = {} }) => (
  <Tooltip title={text} trigger={trigger} className={className} style={style} options={options}>
    <span className="help">?</span>
  </Tooltip>
);

export default Help;
